import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2992f55a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "d-flex align-center",
  style: {"padding":"25px"}
}
const _hoisted_3 = { style: {"flex":"0.5"} }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"40px","color":"#67c8f0","font-weight":"700"} }, " #hydratefreewater ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1","padding":"0 25px"} }, [
  /*#__PURE__*/_createElementVNode("video", {
    width: "1280",
    preload: "auto",
    autoplay: "",
    muted: "",
    playsinline: "",
    style: {"visibility":"visible","width":"95%","margin":"50px 0"}
  }, [
    /*#__PURE__*/_createElementVNode("source", {
      src: "https://www.freewater.io/wp-content/uploads/2022/06/hero-2.mp4",
      type: "video/mp4"
    })
  ])
], -1))
const _hoisted_7 = { style: {"flex":"0.5","font-size":"50px","line-height":"55px"} }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "h-adv-content" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "h-indv-content eql-width" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "52",
  src: "https://i0.wp.com/freewater.io/wp-content/uploads/2022/05/453-savings-pig-outline-2.png?w=1080&is-pending-load=1",
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Save Money", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bottled water costs 2,000 times the price of tap water", -1))
const _hoisted_15 = { class: "h-indv-content eql-width" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "52",
  src: "https://i0.wp.com/freewater.io/wp-content/uploads/2022/05/1159-octopus-outline.png?w=1080&is-pending-load=1",
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Eco-friendly", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our goal is to be net positive by 2030", -1))
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "h-indv-content eql-width" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "52",
  src: "https://i0.wp.com/freewater.io/wp-content/uploads/2022/05/447-water-drop-outline.png?w=1080&is-pending-load=1",
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Premium Water", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hydrate freeWater is natural spring water and all of our containers are BPA free", -1))
const _hoisted_24 = { class: "h-indv-content eql-width" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "52",
  src: "https://i0.wp.com/freewater.io/wp-content/uploads/2022/05/436-love-care-outline.png?w=1080&is-pending-load=1",
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Save Lives", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ten cents from each beverage is donated to charity to build water wells for people in need", -1))
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { class: "d-flex align-center" }
const _hoisted_30 = { class: "eql-width" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  width: "1280",
  height: "720",
  preload: "auto",
  loop: "",
  autoplay: "",
  muted: "",
  playsinline: "",
  style: {"width":"100%"}
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://www.freewater.io/wp-content/uploads/2022/07/spinning-box.mp4",
    type: "video/mp4"
  })
], -1))
const _hoisted_32 = { class: "eql-width" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.25"} }, [
  /*#__PURE__*/_createTextVNode("Hydrate freeWater is an"),
  /*#__PURE__*/_createElementVNode("strong", null, " innovative advertising platform"),
  /*#__PURE__*/_createTextVNode(" that utilizes "),
  /*#__PURE__*/_createElementVNode("strong", null, "premium spring water"),
  /*#__PURE__*/_createTextVNode(" as a new type of advertising medium while prioritizing "),
  /*#__PURE__*/_createElementVNode("strong", null, "philanthropy and sustainability"),
  /*#__PURE__*/_createTextVNode(". Ten cents from each beverage is "),
  /*#__PURE__*/_createElementVNode("strong", null, "donated to charity"),
  /*#__PURE__*/_createTextVNode(" to build water wells for people in need. "),
  /*#__PURE__*/_createElementVNode("strong", null, "We only need 10% of Americans to choose Hydrate freeWater so we can solve the global water crisis permanently")
], -1))
const _hoisted_34 = { class: "container" }
const _hoisted_35 = {
  class: "d-flex align-center",
  style: {"gap":"20px"}
}
const _hoisted_36 = { style: {"flex":"0.8","margin-bottom":"20px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "We are partnered with WellAware", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.25"} }, "We donate ten cents per beverage to WellAware, an Austin based non-profit that builds water wells in East Africa. Every 150 FreeWaters donates enough money to provide one person with a safe water source for the rest of their life.", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "outline-btn" }, "Learn More", -1))
const _hoisted_40 = { style: {"flex":"1.2"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://i0.wp.com/www.freewater.io/wp-content/uploads/2022/05/wellaware-1.jpg?w=888&ssl=1",
  alt: ""
}, null, -1))
const _hoisted_42 = { class: "container" }
const _hoisted_43 = {
  class: "d-flex align-center",
  style: {"gap":"20px"}
}
const _hoisted_44 = { class: "eql-width" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://i0.wp.com/www.freewater.io/wp-content/uploads/2022/05/Slide1-1.jpg?w=973&ssl=1",
  alt: ""
}, null, -1))
const _hoisted_46 = { class: "eql-width" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "We never use plastic bottles", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2.25"} }, "The world is producing a million plastic bottles per minute and only 9% are being recycled. That's a half trillion bottles annually that will end up in landfills, rivers, lakes, and the ocean. Things have become so bad that scientists predict plastic in our oceans will outweigh fish by 2050.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypewriterEffect = _resolveComponent("TypewriterEffect")!
  const _component_html_visibility = _resolveComponent("html-visibility")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "outline-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectTo('/advertise')))
          }, "Advertise with us")
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TypewriterEffect, {
          textToType: _ctx.customText,
          typingSpeed: 100
        }, null, 8, ["textToType"])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("section", _hoisted_11, [
            _createVNode(_component_html_visibility, {
              "animate-style": "fade-in",
              "animation-duration": "2s"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _createElementVNode("section", _hoisted_15, [
            _createVNode(_component_html_visibility, {
              "animate-style": "fade-in",
              "animation-duration": "2s"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _hoisted_17,
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("section", _hoisted_20, [
            _createVNode(_component_html_visibility, {
              "animate-style": "fade-in",
              "animation-duration": "2s"
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23
              ]),
              _: 1
            })
          ]),
          _createElementVNode("section", _hoisted_24, [
            _createVNode(_component_html_visibility, {
              "animate-style": "fade-in",
              "animation-duration": "2s"
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _hoisted_26,
                _hoisted_27
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-right",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-left",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-right",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38,
              _hoisted_39
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-left",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-right",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_html_visibility, {
            animateStyle: "fade-in-left",
            animationDuration: "0.5s"
          }, {
            default: _withCtx(() => [
              _hoisted_47,
              _hoisted_48
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}